module.exports = __webpack_public_path__ + "img/vtd-system-image2.38eee969.jpeg";